export default __webpack_public_path__ + "assets/85331ef70aa2a2797986a4b15868e4af.png";